import React from "react";
import CustomCreatableMultiSelect from "../CustomCreatableMultiSelect";
import "./creatableSelectWithDescription.scss";

const CreatableSelectWithDescription = (props) => {
  const {
    name,
    inputLabel,
    sectionName,
    options,
    menuIsOpen,
    value,
    hideInput,
    textAreaPlaceholder,
    textAreaMaxLength,
    descriptionValue,
    handleSearch,
    handleSelect,
    handleOnChange,
    handleDescriptionText,
    handleRemove,
    maxApiCall,
    setPageNo,
    pageNo,
    closeMenu,
    handleCustomInput,
  } = props;
  return (
    <div className="createble-select-container">
      <CustomCreatableMultiSelect
        name={name}
        inputLabel={inputLabel}
        sectionName={sectionName}
        options={options}
        menuIsOpen={menuIsOpen}
        value={[value]}
        handleSearch={handleSearch}
        handleSelect={handleSelect}
        handleOnChange={handleOnChange}
        handleRemove={handleRemove}
        showDelete={true}
        maxApiCall={maxApiCall}
        setPageNo={setPageNo}
        pageNo={pageNo}
        hideInput={hideInput}
        closeMenu={closeMenu}
        handleCustomInput={handleCustomInput}
      />
      <textarea
        className="description-text"
        maxLength={textAreaMaxLength ?? 250}
        placeholder={textAreaPlaceholder}
        value={descriptionValue}
        onChange={(e) => handleDescriptionText(name, e.target.value)}
      />
    </div>
  );
};

export default CreatableSelectWithDescription;
